import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

function ProtectedRoute({ children }) {
  const isAuthenticated = Cookies.get('KTisAuthenticated') === 'true';
  return isAuthenticated ? children : <Navigate to="/kernteamportal" replace />;
}

export default ProtectedRoute;
